import StrikeThroughPrice from '@imageTheme/mobile/BlackFriday2023/BF2023-X.webp';
import Image from 'next/image';
import {priceHelper} from '@helpers/config-master.mjs';
import cn from 'clsx';
import {LoadAffirmScript} from '@components/affirm/load-affirm-script';
import {niceMoney} from '@helpers/common/number.mjs';
import {HStack} from '@components/widgets/Common';
import {formatPriceNumeric} from '@components/product/global/formatPriceNumeric';
import {useSession} from 'next-auth/react';

export const PricesDesktop = ({product}) => {
  const {data: session} = useSession();
  const user = session?.user;
  const isDealer = user?.isDealer;

  let selectedVariant = product;
  let salePriceValue = priceHelper.getFinalPrice(selectedVariant);
  let isSaleEnabled = priceHelper.saleEnabledFor(selectedVariant);
  // console.log({salePriceValue, isSaleEnabled})

  return (
    <div className="mt-2 mb-2">
      <HStack>
        {isDealer && (
          <DealerPricingDesktop product={product}/>
        )}

        {!isDealer && (
          <div>
            {!isSaleEnabled && <NormalPricing product={product}/>}
            {isSaleEnabled && <SalePricing product={product}/>}
          </div>
        )}
      </HStack>

      {!isDealer && (
        <div id="div-affirm">
          <LoadAffirmScript price={salePriceValue}/>
        </div>
      )}
    </div>
  );
};

export function NormalPricing({product}) {
  const selectedVariant = product?.selectedVariant ?? product;
  const {map_price, msrp_price} = useAllPrices(selectedVariant);
  return (
    <>
      <div className="flex flex-col">
        <div className="text-gray-500 w-fit text-lg relative font-normal flex line-through">
          {`MSRP: ${niceMoney(msrp_price)}`}
        </div>
        <div className="text-2xl whitespace-nowrap">
          Price: <span className="font-bold">{niceMoney(map_price)}</span>
        </div>
      </div>
    </>
  );
}

export function SalePricing({product}) {
  // console.log({salePricing_product: product});
  const selectedVariant = product?.selectedVariant ?? product;
  const {sale_price, map_price, msrp_price} = useAllPrices(selectedVariant);
  // console.log({salePrice: sale_price, mapPrice: map_price, msrpPrice: msrp_price})

  let isInStock = product?.currentlyInStock; /* useProductStock?.isInStock;*/
  let preorderInfo = product?.preorderInfo; /*useProductStock?.pre_order_info;*/

  let isPreOrderEnabled = preorderInfo?.is_pre_order_enabled;
  let isPreOrderEligible = preorderInfo?.is_pre_order_eligible;
  let isPreorder = !isInStock && isPreOrderEnabled && isPreOrderEligible;
  // console.log({isPreorder});

  const isSaleEnabled = priceHelper.saleEnabledFor(selectedVariant);

  const msrpPrice = niceMoney(msrp_price);
  const mapPrice = niceMoney(map_price);
  const salePrice = niceMoney(sale_price);

  return (
    <>
      <div className="flex flex-row gap-3">
        <div className="text-gray-500 w-fit text-lg relative font-normal flex line-through">
          {`MSRP: ${msrpPrice}`}
        </div>

        <div className="text-gray-700 text-lg flex border-left relative">
          Price:
          <div className={'relative ml-1'}>
            {mapPrice}
            <div className={'absolute top-1 left-1 opacity-80'}>
              <Image src={StrikeThroughPrice} alt="Strike Through Price"/>
            </div>
          </div>
        </div>
      </div>

      {/*<div*/}
      {/*  className={cn('text-3xl whitespace-nowrap font-bold', {*/}
      {/*    'text-skar-red-dark': !isPreorder,*/}
      {/*    'text-sky-700': isPreorder*/}
      {/*  })} >*/}
      {/*Price:*/}

      <div /*THIS DIV FOR BF/CM ONLY - DISABLE AND RE_ENABLE ABOVE SNIPPET FOR NORMAL PRICE */
        className={cn('text-2xl whitespace-nowrap font-bold')}
        style={{color: 'rgba(4,43,138, 1)'}}
      >
        Summer Sales Event Price:


        {/*<span*/}
        {/*  className={cn('font-bold ml-1', {*/}
        {/*    'text-skar-red-dark': !isPreorder,*/}
        {/*    'text-sky-700': isPreorder*/}
        {/*  })}>*/}
        {/*  {salePrice}*/}

        <span
          className={cn('font-bold ml-1')}>
          {salePrice}
        </span>
      </div>
    </>
  );
}

export const DealerPricingDesktop = ({product}) => {
  const selectedVariant = product?.selectedVariant ?? product;
  const priceDealer = selectedVariant?.price_dealer ?? product?.priceDealer;

  const {sale_price, map_price} = useAllPrices(selectedVariant);
  // console.log({sale_price, map_price})

  const isSaleEnabled = priceHelper.saleEnabledFor(selectedVariant);

  const isInStock = product?.inStock ?? product?.isInStock;
  const preorderInfo = product?.preorderInfo ?? null;

  const isPreOrderEnabled = preorderInfo?.is_pre_order_enabled;
  const isPreOrderEligible = preorderInfo?.is_pre_order_eligible;
  const isPreorder = !isInStock && isPreOrderEnabled && isPreOrderEligible;

  return (
    <div>
      <div className="flex flex-row gap-3">
        <div className="text-gray-500 w-fit text-lg relative font-normal flex line-through">
          {`MAP: ${niceMoney(map_price)}`}
        </div>

        {isSaleEnabled && (
          <div className="text-gray-700 text-lg flex border-left">
            {/*SALE PRICE:*/}
            SUMMER SALES EVENT PRICE:
            <span
              className={cn('ml-1', {
                'line-through': isSaleEnabled
              })}>
              {niceMoney(sale_price)}
            </span>
          </div>
        )}
      </div>

      <div className="text-2xl whitespace-nowrap">
        Dealer:{' '}
        <span
          className={cn('font-bold', {
            'text-sky-700': !isPreorder,
            'text-black': isPreorder
          })}>
          {niceMoney(priceDealer)}
        </span>
      </div>
    </div>
  );
};

export const useAllPrices = (selectedVariant) => {
  const priceMap = selectedVariant?.price_map ?? selectedVariant?.priceMap;
  const priceMsrp = selectedVariant?.price_msrp ?? selectedVariant?.priceMsrp;
  const sale_price = formatPriceNumeric(priceHelper.getFinalPrice(selectedVariant));
  const map_price = formatPriceNumeric(priceMap);
  const msrp_price = formatPriceNumeric(priceMsrp);
  // console.log("useAllPrices", {sale_price, map_price, msrp_price});

  return {
    sale_price,
    map_price,
    msrp_price
  };
};
